module.exports = (process.env.NODE_ENV === "production") ? {
  BASE_URL: "https://sleeker.pt/",
  BASE_API_URL: "https://api.sleeker.pt/",
  EDITOR_URL: "https://editor.sleeker.pt/",
  STRIPE_KEY: "pk_test_GGCtlmVli3N90r7fHisyygZc00ylIauezq"
} : {
  BASE_URL: "http://localhost:8080/",
  BASE_API_URL: "http://localhost:8000/",
  EDITOR_URL: "http://localhost:4200/",
  STRIPE_KEY: "pk_test_GGCtlmVli3N90r7fHisyygZc00ylIauezq"
}


/*
{
  BASE_URL: "http://192.168.3.88:8080/",
  BASE_API_URL: "http://192.168.3.88:8000/",
  EDITOR_URL: "http://192.168.3.88:4200/",
  STRIPE_KEY: "pk_test_GGCtlmVli3N90r7fHisyygZc00ylIauezq"
}*/
